import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as firebase from 'firebase/app';
import { AppConfiguration } from 'src/app/app.configuration';
import { PubqConfig, PubqConfigProvider } from '../pubq-config/pubq-config';
import { ContextProvider } from '../context/context';
let appSettings = require("../../../../cordova-scripts/appsettings");

@Injectable({
  providedIn: 'root'
})

export class AnalyticsService {
  origin = AppConfiguration.userOrigin;
  config: PubqConfig;
  context = {};
  shouldLog = false;
  appBuild = 'N/A'

  constructor(
    private http: HttpClient,
    private pubqConfigProvider: PubqConfigProvider,
    private contextProvider: ContextProvider
  ) {

    this.appBuild = "web-" + appSettings && appSettings.version ? appSettings.version : 'N/A';

    this.pubqConfigProvider.config.subscribe((x: PubqConfig) => {
      if (!x) {
        return;
      }
      this.config = x;
      this.shouldLog = this.config.sendLogEvents ? this.config.sendLogEvents : false;
    });

    this.setContextValue('origin', this.origin);
    this.setContextValue('appVersion', this.appBuild);
  }

  trackEvent(event: string, payload?) {
    if (!this.shouldLog) return;
    this.setContextValue('timestamp', +new Date());
    this.setContextValue('routeName', this.contextProvider.client ? this.contextProvider.client.routeName : null);

    if (firebase.auth().currentUser)
      this.setContextValue('userId', firebase.auth().currentUser.uid);

    const body = {
      eventKey: event,
      payload,
      context: this.context
    };
    try {

      this.http.post<any>(this.config.ApiUrl + '/api/v1/curator', body)
        .toPromise()
        .then(res => {
        }, err => {
          console.log('event adding error', err);
        });
    } catch (err) {
      console.log("Error sending event to server (" + event + ")");
    }
  }

  setContextValue(key, val) {
    this.context[key] = val;
  }
}
